import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.wallet,
    props.app.cashapp_cashout,
    (wallet, cashapp_cashout) => {
        return {
            wallet,
            cashapp_cashout
        }
    }
)